import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from 'src/app/shared/shared.module';
import { SlickCarouselUtilService } from '../../../utility/slick-carousel.util';
import { SpecialOfferComponent } from './special-offer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    MediaModule,
    I18nModule,
    SlickCarouselModule,
    SharedModule,
    SpecialOfferComponent,
  ],
  providers: [
    SlickCarouselUtilService,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoCategoryFeatureListComponent: {
          component: SpecialOfferComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class SpecialOfferModule {}
